import React, { useEffect } from 'react';
//import { Modal } from 'antd';
//import { capitalize } from '../libs/helpers';
//import zzz from '../static/zzz.gif';

const Idletime = ({ userInfo, setIsSleepy, logOut }) => {
  const sleepTime = 5 * 60 * 1000;
  let sleepTimeout;
  const signoutTime = 30 * 60 * 1000;
  let logoutTimeout;
  const userName = userInfo.email.split('@')[0];  

  
  const logout = () => {    
    setIsSleepy(false);
    logOut();
  };

  const seepModeActive = () => {
    //NAda para mostrar
  };

  const setTimeouts = () => {
    sleepTimeout = setTimeout(seepModeActive, sleepTime);
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  const clearTimeouts = () => {
    if (sleepTime) clearTimeout(sleepTimeout);
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  useEffect(() => {
    const events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress'
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
      setIsSleepy(false);
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    };
  }, []);

  return <></>;
};
export default Idletime;
